export default __webpack_public_path__ + "static/img-finish-products-ba88ec6253893498f3810c70f9b297bb.webp";